<app-layout-secure-header />

<mat-sidenav-container>
  <mat-sidenav #sideStart>
    <app-layout-secure-side />
  </mat-sidenav>

  <mat-sidenav-content id="main-scroll">
    <router-outlet />
  </mat-sidenav-content>

  <mat-sidenav #sideEnd (closed)="sideEndOpened = false" [opened]="sideEndOpened" position="end">
    <ng-template app-layout-side-end></ng-template>
  </mat-sidenav>
</mat-sidenav-container>

<app-layout-secure-footer />

<div id="to-top">
  <button (click)="scrollToTop()" color="primary" mat-mini-fab>
    <mat-icon>expand_less</mat-icon>
  </button>
</div>
